import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'

import { RootState } from 'redux/store'
import { City } from 'data/Cities'

export interface CitiesState {
    list: City[]
}

export const initialState: CitiesState = {
    list: [],
}

const citiesSlice = createSlice({
    name: 'cities',
    initialState,
    reducers: {
        citiesReceived: (state, { payload: cities }: PayloadAction<City[]>) => {
            state.list = cities
        },
    },
})

const { actions, reducer } = citiesSlice
export default reducer

export const getCities = (store: RootState) => store.cities.list

export const getCityLink = (store: RootState, cityName: string) =>
    createSelector(getCities, cities => {
        const city = cities.find(city => city.name === cityName)

        return city?.link
    })(store)

export const { citiesReceived } = actions
